import { useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useAppSettings = () => {
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: ['appSettings'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return null;

      const { data } = await supabase
        .from('settings')
        .select('show_linkedin_section, auto_enrichment_enabled')
        .eq('user_id', user.id)
        .maybeSingle();
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });

  const invalidate = () => queryClient.invalidateQueries({ queryKey: ['appSettings'] });

  return {
    showLinkedInSection: data?.show_linkedin_section ?? false,
    autoEnrichmentEnabled: data?.auto_enrichment_enabled ?? true,
    isLoading,
    invalidate,
  };
};
